import CONST from './constant';
import Util from './util';

const base = (items, value) => {
  let findItem = items.find(item => item.id == value);
  return findItem ? findItem.name : '';
};

export default {
  fm: Util.fm,
  sex: (val) => {
    return base(CONST.SEX, val);
  },
  fmProcessType: (_row, _column, cellValue) => {
    return base(CONST.HR_PROCESS_TYPE, cellValue);
  },
  fmProcessStatus: (_row, _column, cellValue) => {
    return base(CONST.HR_PROCESS_STATUS, cellValue);
  },
  fmMoney: (_row, _column, cellValue) => {
    return Util.fm(cellValue);
  },
  fmCostWxView: (_row, _column, cellValue) => {
    return base(CONST.COST_WX_VIEW, cellValue);
  },
  // 格式化代收代付类型
  fmThirdPartyCostType: (_row, _column, cellValue) => {
    return base(CONST.THIRD_PARTY_COST_TYPE, cellValue);
  },
  fmProductCycleType: (_row, _column, cellValue) => {
    return base(CONST.PRODUCT.CYCLE_TYPE, cellValue);
  },
  fmServBeginEndDate: (_row, _column, cellValue) => {
    if(_row.cycle_type == 1) {
      return '';
    } else if(_row.cycle_type > 1
      && _column.property == 'end_date'
      && cellValue == CONST.MAX_SERV_DATE) {
      return '';
    } else {
      return cellValue.substring(0, 7);
    }
  },
  // 格式化发票状态
  fmInvoiceStatus: (_row, _column, cellValue) => {
    return base(CONST.INVOICE_STATUS, cellValue);
  },
  // 格式化发票类型
  fmInvoiceType: (_row, _column, cellValue) => {
    return base(CONST.INVOICE_TYPE, cellValue);
  },
  // 格式化发票费用类型
  fmInvoiceFeeType: (_row, _column, cellValue) => {
    return base(CONST.INVOICE_FEE_TYPE, cellValue);
  },
  // 格式化 用户/员工状态
  fmStatus: (_row, _column, cellValue) => {
    return base(CONST.STATUS, cellValue);
  },
  // 格式化 电子票据状态
  fmElecnotesStatus: (_row, _column, cellValue) => {
    return base(CONST.ELECNOTES_STATUS, cellValue);
  },
  // 格式化 使用状态
  fmUsefulStatus: (_row, _column, cellValue) => {
    return base(CONST.USEFUL_STATUS, cellValue);
  },
  fmCostStatus: (_row, _column, cellValue) => {
    return base(CONST.COST_STATUS, cellValue);
  },
  fmConsultStatus: (_row, _column, cellValue) => {
    return base(CONST.CONSULT_STATUS, cellValue);
  },
  fmRoyaltyStatus: (_row, _column, cellValue) => {
    return base(CONST.ROYALTY_STATUS, cellValue);
  },
  // 格式化 员工状态 显示
  fmEmployeeStatus: (_row, _column, cellValue) => {
    return base(CONST.EMPLOYEE_STATUS, cellValue);
  },
  // 格式化 性别 显示
  fmSex: (_row, _column, cellValue) => {
    return base(CONST.SEX, cellValue);
  },
  // 格式化收据本状态
  fmReceiptBookStatus(_row, _col, val) {
    return CONST.RECEIPT_BOOK_STATUS[val - 1].label
  },
  // 格式化收据状态
  fmReceiptStatus(_row, _col, val, _ind) {
    return CONST.RECEIPT_STATUS[val - 1].label
  },

  // 格式化 日期 显示
  fmDate: (_row, _column, cellValue) => {
    return cellValue.replace(/T.+$/, '')
  },
  fmCurrentDate: (_row, _column, cellValue) => {
    return (cellValue == CONST.NO_DATE || cellValue == CONST.MAX_SERV_DATE) ? '' : cellValue;
  },
  // 格式化人力员工社保状态
  fmSocialStatus: (_row, _column, cellValue) => {
    return base(CONST.HR_SOCIAL_STATUS, cellValue || 2 );
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/filter.js